import { render, staticRenderFns } from "./VPSPwdLessPassword.vue?vue&type=template&id=7899623c&scoped=true"
import script from "./VPSPwdLessPassword.vue?vue&type=script&lang=js"
export * from "./VPSPwdLessPassword.vue?vue&type=script&lang=js"
import style0 from "./VPSPwdLessPassword.vue?vue&type=style&index=0&id=7899623c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7899623c",
  null
  
)

export default component.exports